module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "altitude-control",
    class: {
      visible: _vm.isVisible
    },
    on: {
      "touchmove": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "big-label",
    class: {
      visible: _vm.bigLabel
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.roundedAltitude) + "m")])]), _vm._v(" "), _c('div', {
    ref: "bar",
    staticClass: "altitude-control-bar",
    on: {
      "mouseover": function($event) {
        _vm.showBigLabel(true)
      },
      "touchstart": function($event) {
        _vm.showBigLabel(true)
      }
    }
  }, [_c('div', {
    staticClass: "up button",
    on: {
      "click": function($event) {
        _vm.climb(250)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-caret-up"
  })]), _vm._v(" "), _c('canvas', {
    ref: "wheel"
  }), _vm._v(" "), _c('div', {
    staticClass: "handle",
    on: {
      "mousedown": _vm.beginMouseMove,
      "touchstart": _vm.beginTouchMove
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "down button",
    on: {
      "click": function($event) {
        _vm.climb(-250)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-caret-down"
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5cca3dd1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/altitude-control.vue
// module id = 338
// module chunks = 1